riot.tag2('dealer-cta-item', '<a href="{urlComposed}" if="{url}" target="{link.target}" class="{link.style}" onclick="{clickEvent}" data-raq="{\'large\': link.behavior == \'raq\'}" data-modal-type="{\'large\': link.behavior == \'raq\'}" data-tracking="{trackingData}" data-automation-id="{link.automationid+\'-\'+index}"> <span> {link.name} </span> </a>', '', 'class="dealer-cta {\'is-detail-container\': link.style.search(\'is-detail\') >= 0}"', function(opts) {
    var self = this;
    var find = require('lodash/collection').find;
    var constants = require('../../core/constants.js').global;
    var trackingJSON = require('../../data/tracking-data');
    var isTrackingFilled = false;
    self.urlComposed = '';

    self.mixin('bus');

    function getParamValue(str) {
      var value = '';
      var keyName;

      if (str.indexOf('[') !== -1) {
        keyName = str.replace('[', '').replace(']', '');
      } else {
        value = str;
      }
      if (self.parent.opts.dealer && keyName && self.parent.opts.dealer[keyName]) {
        value = self.parent.opts.dealer[keyName];
      }
      return value;
    }

    function setTrackingData() {
      var dealer = self.parent.opts.dealer;
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.dealerCTA));
      jsonData.Dealer.selected_dealer_id = dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = dealer.Name;
      jsonData.Dealer.selected_dealer_address = dealer.Address + ', ' + dealer.City;

      if (self.link.name.toUpperCase() === 'DEALER WEBSITE') {
        jsonData.Dealer.selected_dealer_link = dealer.WebAddress;
      }

      if (self.link.style.indexOf('acr-cta-btn') > -1) {
        jsonData['Event Metadata'].action_type = 'cta';
      }

      if (self.parent.opts.view) {
        jsonData.dynamic_variables[0].search += 'dealer details:[selected_dealer_name]:[click text]';
        jsonData.dynamic_variables[2].search = 'locate dealer details';
      } else {
        jsonData.dynamic_variables[0].search += 'results:[click text]';
        jsonData.dynamic_variables[2].search += 'results';
      }

      self.trackingData = JSON.stringify(jsonData);
    }

    function setUrlValues() {
      var qStr = '';
      var dealerAttributes = self.parent.opts.dealer.Attributes;
      var url = self.link.urltoken !== '' ? getParamValue(self.link.urltoken) : self.link.url;
      var paramObj = self.link.parameters;
      var paramsObj = {};
      var parameters = [];
      var internetCertified;
      var showRaq = true;
      var nonServiceCenter = true;

      internetCertified = find(dealerAttributes, { Code: constants.INTERNET_CERTIFIED });
      if (!internetCertified && self.link.behavior === constants.CTA_RAQ_BEHAVIOR) {
        showRaq = false;
      }

      if (self.link.hidefromservicecenter && self.parent.opts.dealer.IsServiceCenter) {
        nonServiceCenter = false;
      }

      if (Object.keys(paramObj).length > 0) {
        qStr = '?';
        Object.keys(paramObj).forEach(function getParam(param) {
          var value = getParamValue(paramObj[param]);
          if (value) {
            qStr += param + '=' + value + '&';
            paramsObj[param] = value;
          }
        });
        parameters.push(paramsObj);
        qStr = qStr.slice(0, -1);
      }
      self.url = (url.length > 0 && showRaq && nonServiceCenter) ? url + qStr : false;
      self.parameters = parameters;
    }

    function getDealerId() {
      return (self.parent.opts.dealer.DealerNumber);
    }

    function updateComposedUrl() {
      if (self.link.behavior === 'raq') {
        self.urlComposed = self.url + '&amp;dealerId=' + getDealerId();
      } else {
        self.urlComposed = self.url;
      }
    }
    self.clickEvent = function clickEvent(event) {
      var result = false;
      var fullPage = window.dealerLocator && window.dealerLocator.fullPage;

      if (self.link && self.link.behavior !== '' && !fullPage && self.isModal) {
        event.preventDefault();
        self.bus.trigger(self.bus.EVENTS.DEALERS.CTA_CLICK,
          {
            type: self.link.behavior,
            parameters: self.parameters,
            url: self.url,
          });
      } else if (self.link && self.link.behavior === 'select') {
        event.preventDefault();
        self.bus.trigger(self.bus.EVENTS.DEALERS.CTA_CLICK,
          {
            type: self.link.behavior,
            parameters: self.parameters,
            url: self.url,
          });
      } else {
        result = true;
      }
      return result;
    };

    self.on('update', function onUpdate() {
      setUrlValues();

      if (self.parent.opts.dealer && !isTrackingFilled) {
        setTrackingData();
        isTrackingFilled = true;
      }
      updateComposedUrl();
    });

    self.on('mount', function onMount() {
      var dlModal = document.getElementsByTagName('dl-content-modal');

      updateComposedUrl();

      if (dlModal.length && dlModal[0]) {
        self.isModal = true;
      } else {
        self.isModal = false;
      }
    });
});
